import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { app, translate } from "../app"
import { languages } from "../locale"
import { translations } from "../translations"
import NotFoundPage from "./notfoundpage"

export function Redirect() {
  const navigate = useNavigate()
  const { sectionid } = useParams()
  const locale = languages[app.locale]?.zendesk as string ?? app.locale
  const section = Object.values(app.data.zendesk.sections).find(x => x.id === +sectionid)

  useEffect(() => {
    if (section) {
      navigate(`/${locale.toLowerCase()}/categories/${section.category}/${section.id}`)
    }
  }, [section, locale, navigate])

  return (
    <div className="flex overflow-y-scroll flex-col">
      <NotFoundPage title={translate(translations.oops)} subTitle={translate(translations.pageNotExist)} />
    </div>
  );
}
